import AppHeader from "./index.vue";
import Vue from "vue";
import {
  ContainerMethods,
  ContainerData,
  ContainerComputed,
  ContainerProps
} from "./types";
import { getZendeskJwt } from "@/api";
import { zendeskUrl } from "@/constants/zendesk";
import {
  saveZendeskLastAuthDate,
  requireZendeskReAuth
} from "@/helpers/zendesk-helper";
import { removeSentryUser } from "@/helpers/sentry-helper";
import { clearSearchOptionInLocalStorage } from "@/components/Pages/Scout/Candidates/methods";
import { clearMenuTypeInLocalStorage } from "@/helpers/menu-type-helper";
import { MenuType } from "@/store/domains/user/types";

interface addProperty extends Document {
  webkitHidden?: any;
  [index: string]: any;
}
declare var document: addProperty;

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      interval: process.env.VUE_APP_NOTIFICATION_POLLING_INTERVAL
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["domains/user/isLoggedIn"];
    },
    newArrivalNotifications() {
      return this.$store.state.domains.notifications.newArrivalNotifications;
    },
    isHeaderNotificationBadgeVisible() {
      return this.$store.getters[
        "domains/notifications/isHeaderNotificationBadgeVisible"
      ];
    }
  },
  beforeCreate() {
    this.$store.dispatch(
      "domains/notifications/initializeNewArrivalNotificationSnapshotForHeaderBadge"
    );
  },
  mounted() {
    this.getNotifications();
  },
  methods: {
    getDocumentHidden() {
      let hidden!: "hidden" | "webkitHidden";
      if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
      } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
      }
      return document[hidden];
    },
    async toZendeskFaq(redirectUrl) {
      if (!requireZendeskReAuth()) {
        window.open(redirectUrl, "_blank", "noopener");
        return;
      }

      try {
        const {
          data: { sso_payload }
        } = await getZendeskJwt();

        // NOTE: local環境と代理ログイン環境
        if (!sso_payload) {
          window.open(redirectUrl, "_blank", "noopener");
          return;
        }

        const zendeskSSOUrlWithRedirect = `${zendeskUrl}/access/jwt?jwt=${sso_payload}&return_to=${redirectUrl}`;

        saveZendeskLastAuthDate();
        window.open(zendeskSSOUrlWithRedirect, "_blank", "noopener");
      } catch (error) {
        window.open(redirectUrl, "_blank", "noopener");
        throw error;
      }
    },
    async getNotifications() {
      if (!this.isLoggedIn) return;
      try {
        if (!this.getDocumentHidden()) {
          await this.$store.dispatch(
            "domains/notifications/getNewArrivalNotifications"
          );
        }
      } catch (error) {
        throw error;
      } finally {
        setTimeout(this.getNotifications, this.interval);
      }
    },
    resetHeaderNotificationBadge() {
      this.$store.dispatch(
        "domains/notifications/resetHeaderNotificationBadge"
      );
    },
    readNotification(notificationId) {
      this.$store.dispatch("domains/notifications/readNotification", {
        notificationId
      });
    },
    resetPerformanceChartFilter() {
      this.$store.dispatch("pages/performances/removePerformanceChartFilter");
    },
    async signOut() {
      try {
        await this.$store.dispatch("domains/user/signOut");
        this.resetPerformanceChartFilter();
        clearSearchOptionInLocalStorage();
        removeSentryUser();
        clearMenuTypeInLocalStorage();
        this.$store.commit(
          "domains/user/changeMenuType",
          MenuType.MENU_DEFAULT
        );
        this.$router
          .push({ name: "SignIn", query: { isLoggedOut: "true" } })
          .catch(err => err);
      } catch (error) {
        throw error;
      }
    }
  },

  render(createElement) {
    return createElement(AppHeader, {
      props: {
        isLoggedIn: this.isLoggedIn,
        notifications: this.newArrivalNotifications,
        isHeaderNotificationBadgeVisible: this.isHeaderNotificationBadgeVisible
      },
      on: {
        clickZendeskUrl: this.toZendeskFaq,
        clickNotificationButton: this.resetHeaderNotificationBadge,
        readNotification: this.readNotification,
        clickSignOut: this.signOut
      }
    });
  }
});
